var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanoramicXRay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1.58108in",
    height: "0.651787in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 519 214",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .str0 {stroke:#CCCCCC;stroke-width:0.984496}\n    .fil1 {fill:#E6E6E6}\n    .fil0 {fill:white}\n    .fil2 {fill:white}\n   "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2975208733296"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M430 62l-1 2c2,10 1,19 8,23 8,3 10,-1 15,-4 6,-4 12,-1 16,-6 7,-9 -7,-23 -9,-28 -6,1 -10,4 -15,7 -5,2 -10,3 -14,6zm-4 5c-2,-2 -1,2 -2,-4 -7,4 -22,9 -32,9l-1 4c-3,36 14,22 24,21 9,-1 16,1 17,-10 0,-9 -6,-14 -6,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M60 52c1,3 1,2 -2,2 -5,3 -13,17 -6,23 4,4 9,3 14,5 4,2 22,19 23,-18l0 -2c-2,-1 -4,-1 -7,-2 -11,-4 -14,-8 -20,-11 -2,3 -1,-2 -2,3zm68 24l-1 -4c-7,0 -12,-1 -17,-3 -5,-2 -10,-4 -15,-5l-2 3c0,8 -9,16 -5,25 3,6 9,4 15,5 12,1 27,16 25,-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M461 49c1,4 4,9 10,9 6,0 6,-3 11,-7 12,-8 19,-4 12,-21 -2,0 -1,0 -1,-2 -2,0 -2,1 -1,-2 -2,1 -2,2 -2,-1l0 0 -2 -2c-5,3 -1,0 -5,4 -1,0 -2,3 -3,4 -13,13 -21,11 -19,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M29 25c0,2 0,2 -2,2 1,2 1,1 -1,1l-1 2c-7,15 1,14 11,19 3,2 5,7 9,9 6,2 10,-3 11,-7 0,-2 0,-1 2,-1l0 -1c-1,-4 -3,-4 -7,-7 -3,-2 -4,-3 -7,-5 -5,-4 -8,-10 -13,-13 -1,1 0,1 -2,1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M428 62l2 0c4,-3 9,-4 14,-6 5,-3 9,-6 15,-7l0 -3 2 3c-2,-7 6,-5 19,-18 1,-1 2,-4 3,-4 4,-4 0,-1 5,-4l2 2 -1 -2 -1 0 0 -1c-11,-1 -12,-22 -28,-21 1,6 4,9 4,13 -4,-2 -6,-6 -10,-5 -1,2 1,5 -1,7 -2,-2 -3,-4 -7,-4 -6,12 12,17 12,35 -7,-9 -7,-18 -20,-21 -5,3 0,0 -6,4l3 14c-4,-5 -6,-11 -12,-11 -3,12 4,19 5,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M31 24c5,3 8,9 13,13 3,2 4,3 7,5 4,3 6,3 7,7l1 -1c8,-23 18,-25 15,-37 -5,1 -4,1 -6,4 0,0 -1,-1 -1,-1l-1 -3c-1,-1 -1,-2 -1,-3 -6,3 -5,4 -10,6l4 -13c-12,-1 -15,9 -21,17 -2,3 -1,1 -3,4 -1,0 -2,1 -2,1l-2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M95 64c5,1 10,3 15,5 5,2 10,3 17,3l1 4 0 -3c0,-12 8,-20 3,-34 -7,0 -7,12 -14,17 -5,-8 2,-28 -8,-16 -2,-7 0,-5 -4,-6 -7,6 -9,19 -10,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M391 72l0 4 1 -4c10,0 25,-5 32,-9 0,-8 -3,-25 -11,-30 0,1 0,1 -1,1l-1 2c0,0 0,1 0,1 -1,1 -1,2 -2,3 0,-4 -1,-3 -5,-4 0,4 0,17 -2,20 -8,-6 -6,-15 -14,-18 -5,10 2,24 3,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M61 48l1 1c6,3 9,7 20,11 3,1 5,1 7,2l2 0c1,-9 10,-22 4,-30 -5,2 -5,6 -11,12 0,-5 2,-6 2,-10 1,-9 -3,-4 -4,-8 0,0 -1,0 -1,0 -13,3 -16,16 -20,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M235 84l22 1 1 11 0 -11 -1 0c-1,-9 -5,-21 -6,-32 -1,-9 0,-23 -7,-29 -1,2 -2,2 -2,7 -3,16 -3,37 -7,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M262 84l22 0c-4,-12 -5,-43 -7,-54 0,0 -1,-3 -1,-3 -1,-2 0,-1 -1,-3 -7,5 -6,21 -8,30 -1,12 -3,20 -5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M313 82l0 1c4,-1 12,-2 17,0 -1,-16 -4,-30 -5,-49 -1,-9 0,-10 -4,-14 -8,18 -5,42 -8,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M188 81l0 1c4,-1 13,0 18,1 -1,-9 -2,-48 -6,-57 -3,-8 2,-3 -4,-6 -1,12 -4,54 -8,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M212 84l17 -1c0,3 -1,2 1,2l-1 -2c-2,-13 -1,-47 -8,-56 -5,6 -7,46 -9,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M338 80l18 -1 1 2 0 -2 -1 0 -8 -41c0,-2 0,-4 -1,-7 -1,-2 -1,-1 -1,-3l-2 -1c-6,9 -6,40 -6,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M288 83l0 3 3 -2c5,-1 11,-1 16,0 -2,-12 -4,-51 -9,-57 -4,5 -5,20 -6,27 0,6 -1,22 -2,27 -1,2 -1,1 -2,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M162 79l0 2c5,-3 12,-1 19,0 0,-8 -1,-47 -7,-54 -4,5 -4,20 -6,27l-5 24c0,0 0,1 -1,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M366 77l-1 1 0 1c2,0 1,1 1,-2 3,0 6,0 9,-1 4,-1 5,-2 9,-2 -1,-9 -8,-40 -13,-46 -7,9 -1,36 -5,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M133 75l0 2c4,-4 3,-3 9,-1 5,1 8,1 11,1l1 2 0 -2 -1 0c-4,-15 2,-36 -4,-49 -2,1 -2,1 -4,5 -3,9 -8,36 -12,42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M385 150c3,8 3,19 11,37 5,10 6,7 10,8 -1,-10 -4,-24 -1,-32 8,1 10,11 15,19 2,3 2,4 7,6 6,-13 -8,-31 -7,-44l-3 1 -32 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M99 144c1,13 -13,34 -6,45 8,-6 11,-24 21,-26 3,9 0,22 -1,32 7,-1 6,-2 9,-8 8,-15 9,-31 13,-35l1 -2 0 -2 1 -3c-3,0 -2,0 -1,3l0 2c-10,1 -24,-4 -35,-5 -1,-8 -1,-8 -1,-17 -2,5 -1,10 -1,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M473 126c6,12 16,28 30,31 -1,-11 -8,-14 -8,-26 13,-1 13,14 23,16 2,-17 -12,-29 -14,-42 -9,6 -19,16 -31,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M15 104c0,11 -19,34 -13,43 7,-1 8,-9 14,-14 4,-3 2,-2 8,-2 -1,10 -7,16 -8,25 8,1 14,-8 18,-12 4,-5 9,-13 12,-18 -8,-2 -24,-15 -30,-19l1 -6 -2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M430 141c7,12 16,34 29,37 -1,-9 -10,-20 -6,-29 9,2 12,15 14,19 2,2 0,1 4,2 0,0 0,-1 0,-1l1 -3c3,-13 -7,-29 -9,-36l-1 1c-2,2 -27,10 -32,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M87 142c-5,-3 -28,-8 -30,-11l-1 0c-4,11 -13,24 -8,39 6,-1 7,-14 14,-19 3,-3 0,-1 4,-2 5,9 -5,19 -5,29 10,-1 23,-26 26,-36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M223 157c0,10 0,19 0,29 0,8 -3,22 2,27 4,-6 12,-46 12,-56l0 0 -14 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M215 157c-3,0 -6,0 -10,0 -7,-1 -4,0 -7,-2 4,15 -8,49 -4,56 9,-5 19,-46 21,-54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M297 157l-16 1c3,12 8,47 13,55 4,-5 2,-45 3,-56l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M142 153c2,16 -7,33 -6,50 5,-2 5,-4 8,-10 9,-16 13,-35 19,-38l1 -2 1 -4c-2,2 0,-1 -2,3 0,0 -1,2 -1,2 -9,-2 -14,-3 -20,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M304 157c4,15 12,48 21,54 0,0 1,-1 1,-1l0 -4c0,-6 -9,-38 -5,-49l0 -2 -17 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M358 154c4,3 3,7 5,12l11 26c1,2 2,4 4,6 3,6 0,3 5,5 1,-16 -7,-33 -7,-51l-18 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M242 158c3,13 -1,46 6,55 1,-1 1,-1 1,-1l2 -4c2,-5 3,-42 6,-48 1,-3 0,-1 2,-3l-1 -5c-1,1 0,1 -1,3l-2 3 -13 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M329 156c1,2 0,0 2,5l7 21c5,14 5,21 13,24 0,-12 -8,-43 -3,-51l-1 -2c-5,3 -10,2 -18,3l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M277 158l-15 -1c3,11 4,30 5,42 0,6 0,11 3,14l2 -2c4,-9 2,-39 5,-53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M172 155c4,9 -4,38 -4,51 14,-5 13,-43 23,-50 0,-2 -1,-1 2,-1l-1 -3c0,1 -1,1 -2,4 -5,-1 -7,0 -11,-1 -9,0 -4,1 -7,-3l0 3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M17 101l-1 6c6,4 22,17 30,19l1 0c0,-2 0,-1 2,-1 -1,-2 -1,-2 2,-1 -1,-2 -1,-2 1,-1 -1,-3 -1,-2 1,-2 0,-2 -1,-2 2,-1l0 -3c1,-3 11,-14 -5,-19 -7,-2 -6,-1 -11,-5 -15,-15 -21,2 -22,8zm40 29l0 1c2,3 25,8 30,11 2,-2 0,0 2,-1 0,-2 0,-2 2,-2l1 -1 1 -2c13,-18 5,-21 -8,-24 -6,-1 -6,-5 -13,-7 -12,-4 -14,13 -15,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M428 139l2 2 0 0c5,0 30,-8 32,-10l0 -2 1 -5 -2 -6c-4,-26 -20,-7 -29,-5 -8,1 -7,1 -12,5 0,14 4,13 8,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M385 122c-3,4 -1,0 -5,4 -2,2 -1,1 -3,4 1,9 2,11 6,19l2 1 32 -5 3 -5c0,-8 0,-21 -9,-22 -8,-1 -10,7 -26,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M100 128c0,9 0,9 1,17 11,1 25,6 35,5l0 -2c-1,-3 -2,-3 1,-3l3 -5 1 -6c1,-14 -11,-8 -20,-12 -8,-3 -19,-10 -21,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M462 115l2 2 1 2c2,0 2,0 1,2 2,-1 2,-1 1,2 2,-1 2,-1 2,1 2,-1 1,-1 1,1 2,0 2,-1 2,1l1 0c12,-5 22,-15 31,-21l0 -2 -2 -3c-8,-25 -21,-7 -25,-5 -13,8 -17,-2 -15,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M354 149c0,0 1,0 1,0 0,4 -1,-1 3,5l18 -2c0,-3 0,-2 2,-2 -2,-7 0,-23 -7,-26 -11,-4 -16,2 -17,3l-5 3c-1,8 2,12 5,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M143 134l-1 19c6,-2 11,-1 20,1 0,0 1,-2 1,-2 2,-4 0,-1 2,-3 3,-6 6,-11 5,-19 -4,-2 -6,-3 -9,-7 -13,0 -16,-1 -18,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M261 87l0 25c4,1 20,3 23,-1 3,-7 1,-16 2,-23l-2 -4 -22 0 -1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M234 88c1,23 -5,25 12,25 4,0 9,0 12,-1l0 -16 -1 -11 -22 -1 -1 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M338 80c-1,6 -1,3 -2,5 0,10 -5,19 7,23 3,1 5,1 8,1 18,-4 9,-20 6,-28l-1 -2 -18 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M162 81c-6,12 -10,22 5,27 6,2 13,-2 15,-5 4,-6 1,-12 1,-18 -1,-2 -1,2 -2,-4 -7,-1 -14,-3 -19,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M366 77c0,3 1,2 -1,2 -1,8 -2,12 -1,19 6,6 14,8 22,2 8,-6 2,-17 -1,-24 -2,0 -1,0 -1,-2 -4,0 -5,1 -9,2 -3,1 -6,1 -9,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M133 77c-13,23 10,34 22,21 1,-6 0,-13 -1,-19l-1 -2c-3,0 -6,0 -11,-1 -6,-2 -5,-3 -9,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M172 152c3,4 -2,3 7,3 4,1 6,0 11,1 1,-3 2,-3 2,-4 15,-23 -14,-32 -20,-20 -2,7 -1,13 0,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M327 152c1,1 1,-1 2,4 8,-1 13,0 18,-3 1,-8 2,-13 0,-21 -5,-4 -7,-5 -15,-5 -11,3 -12,18 -5,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M313 83c0,6 0,2 -2,4 1,8 -3,17 4,22 7,6 14,0 19,-3l-1 -21 -3 -2c-5,-2 -13,-1 -17,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M188 82c-1,8 -4,15 -3,24 5,4 12,9 19,3 7,-5 4,-15 3,-23l-1 -3c-5,-1 -14,-2 -18,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M210 87c3,18 -7,24 11,24 5,0 6,0 10,-1l1 -21 -2 -4c-2,0 -1,1 -1,-2l-17 1c-1,5 -1,2 -2,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M288 86l0 25c7,0 15,1 20,-2 2,-6 0,-15 1,-23l-2 -2c-5,-1 -11,-1 -16,0l-3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M198 155c3,2 0,1 7,2 4,0 7,0 10,0l2 -1 2 -13 0 -6c-1,-5 -3,-6 -8,-8 -15,3 -15,9 -13,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M300 137l0 6c-1,7 1,6 1,12l3 2 17 -2c1,-18 3,-22 -14,-26 -5,3 -6,3 -7,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M260 154l2 3 15 1 2 -21c-6,-1 -12,-2 -17,1l-2 16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M281 158l16 -1c-1,-6 1,-14 -2,-21l-10 0 -4 0c-2,7 0,15 0,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M242 158l13 0 2 -3c1,-2 0,-2 1,-3l0 -15 -17 -1 1 22z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2 str0",
    points: "223,157 237,157 239,151 239,136 234,136 223,137 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M377 130c2,-3 1,-2 3,-4 4,-4 2,0 5,-4 -7,1 -7,2 -8,8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanoramicXRay);
export default __webpack_public_path__ + "static/media/PanoramicXRay.64042b194dc201e8141ed28ae7dabde0.svg";
export { ForwardRef as ReactComponent };